<template functional>
  <a-sub-menu :key="props.menuInfo.path">
    <span slot="title">
      <a-icon
        v-if="props.menuInfo.meta.icon"
        :type="props.menuInfo.meta.icon"
        :style="{ fontSize: '18px' }"
      />
      <span>{{ props.menuInfo.meta.title }}</span>
    </span>
    <template v-for="item in props.menuInfo.children">
      <a-menu-item
        v-if="!item.children"
        :key="item.path"
        @click="props.menuItemClicked"
      >
        <a-icon
          v-if="item.meta.icon"
          :type="item.meta.icon"
          :style="{ fontSize: '18px' }"
        />
        <span>{{ item.meta.title }}</span>
      </a-menu-item>
      <sub-menu
        v-else
        :key="item.path"
        :menuInfo="item"
        :menuItemClicked="props.menuItemClicked"
      />
    </template>
  </a-sub-menu>
</template>
<script>
export default {
  props: ['menuInfo', 'menuItemClicked']
}
</script>
